import React, { Fragment, useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Backdrop,
  Avatar,
} from "@material-ui/core";
import {
  palette,
  msmSwalExito,
  msmSwalError,
} from "configurations/styles/theme";
import { httpCore, clientBackendPDF } from "configurations/axios";
import { getRUCEmpresa, getSub } from "redux/actions/userActions";
import { useSelector, useDispatch } from "react-redux";
import SaveIcon from "@material-ui/icons/Save";
import pdfIcon from "assets/icons/pdf.png";
import bigDecimal from "js-big-decimal";
import { format } from "date-fns";
//Notificacion errores https://iamhosseindhv.com/notistack/demos#variants
import { useSnackbar } from "notistack";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import { ConfirmAlert, iconsAlert, ErrorsAlert } from "utils/AlertsCustom";
import { selectedResourceAction } from "redux/actions/resourcesActions";
import {
  checkPreRequirements,
  checkPreRequirementsVoucher,
} from "widgets/menu/preRedirect";
import {
  getNumberVoucher,
  getNumberVoucherSuccess,
} from "redux/actions/numberVouchersAction";
import moment from "moment";
import AddTemplateBtn from "../../../../../widgets/Cafe";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.primary,
    margin: theme.spacing(1),
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "1%",
    borderStyle: "solid",
    boxShadow: "5px 3px 3px #aaaaaa",
    borderRadius: "8px",
    justifyContent: "center",
    borderWidth: "1px",
  },
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  divForm: {
    marginBottom: "1%",
    textAlign: "justify",
  },

  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  msgDialog: {
    padding: "2%",
  },
  btnReport: {
    borderRadius: "8px",
    borderStyle: "dashed",
    borderWidth: "1px",
    borderColor: palette.primary.main,
    color: palette.primary.main,
    marginTop: "1%",
    marginRight: "1%",
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
}));

const ElectronicVoucherOptions = ({
  clearAllData,
  fechaEmision,
  factura,
  setFactura,
  detalles,
  pagos,
  informacionPagos,
  informacionComercial,
  additionalInfoInvoice,
  retentionInfoInvoice,
  logisticInfoInvoice,
  rucsAutorizados,
  propina,
  idCliente,
  consumidorFinal,
  totals,
  additionalDiscountInvoice,
  exportInvoice,
  documentsFiscalReference,
  informationDeliveryPlace,
  invoiceDataGeneral,
  destinoOperacion,
}) => {
  const classes = useStyles();
  const tokenUser = useSelector((state) => state.user.tk);
  const [open, setOpen] = React.useState(false);
  const [msg, setMsg] = React.useState("");
  const [openLoader, setOpenLoader] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const selectedResource = (resource) =>
    dispatch(selectedResourceAction(resource));
  const getNumberVouchers = (resource) => dispatch(getNumberVoucher(resource));
  const previousResourceDenied = useSelector(
    (state) => state.resources.resourceDenied
  );
  //codigo del template para generar
  const [updateTemplate, setUpdateTemplate] = useState('');
  //estado que controla si se hace o no lo prerequisitos para generar el ride
  //0: neutro, 1: genera cafe, 2:firma y autoriza
  const [sendTemplate, setSendTemplate] = useState(0);

    useEffect(()=>{
      if(sendTemplate === 1){
        validatePrerequisities(true);
      }else if(sendTemplate === 2){
        validatePrerequisities(false)
      }
      setSendTemplate(0)
    },[updateTemplate, sendTemplate])

  const configGetNumberVoucher = {
    uri: "/paquete/disponible/",
    tok: tokenUser ? tokenUser : "0",
  };

  const createFactura = () => {
    
    if (validation()) {
      if (validateParametersPayment()) {
        let infos = [];
        if (additionalInfoInvoice.length > 0) {
          infos = additionalInfoInvoice.map(function (info) {
            return {
              nombre: info.nombre,
              valor: info.valor
            };
          });
        }

        return {
          detalles: detalles,
          //fechaEmision:fechaEmision.toISOString().substring(0, 10),
          fechaEmision: moment(fechaEmision).format("YYYY-MM-DDTHH:MM:ssZ"),
          idAsignacionEmpresaUsuario: Number(getSub(tokenUser)),
          idAsignacionEmpresaCliente: idCliente.idAsignacionEmpresaCliente,
          nombreCliente:  idCliente.idAsignacionEmpresaCliente !== 0?idCliente.nombres:null,
          correoCliente:  idCliente.idAsignacionEmpresaCliente !== 0?idCliente.correo:null,
          idConsumidorFinal: consumidorFinal.id ? consumidorFinal.id : null,
          nombreConsumidorFinal: consumidorFinal.nombre
            ? consumidorFinal.nombre
            : null,
          formasPago: pagos ? pagos : [],
          rucEmisor: getRUCEmpresa(tokenUser),
          tipoDocumento: invoiceDataGeneral.iDoc,
          descuentosAdicionales: additionalDiscountInvoice
            ? additionalDiscountInvoice
            : null,
          destinoOperacion:
            invoiceDataGeneral.iDoc === "03"  || invoiceDataGeneral.iDoc === "10"
            ? 2
            : destinoOperacion, 
          entregaCafe: invoiceDataGeneral.entregaCafe,
          formatoCafe: invoiceDataGeneral.formatoCafe,
          fechaContingencia:
            invoiceDataGeneral.fechaContingencia != ""
              ? invoiceDataGeneral.fechaContingencia
              : null,
          motivoContingencia:
            invoiceDataGeneral.motivoContingencia != ""
              ? invoiceDataGeneral.motivoContingencia
              : null,
          tipoEmision: invoiceDataGeneral.tipoEmision,
          fechaSalida:
            invoiceDataGeneral.fechaSalida !== "" && invoiceDataGeneral.fechaSalida !== null
              ? format(
                new Date(invoiceDataGeneral.fechaSalida),
                "yyyy-MM-dd'T'HH:mm:ssXXX"
              )
              : null,
          informacionInteresEmisor:
            invoiceDataGeneral.informacionInteresEmisor != ""
              ? invoiceDataGeneral.informacionInteresEmisor
              : null,
          informacionLogisticaDto:
            Object.keys(logisticInfoInvoice).length !== 0
              ? logisticInfoInvoice
              : null,
          naturalezaOperacion: invoiceDataGeneral.naturalezaOperacion,
          tiempoPago: invoiceDataGeneral.tiempoPago,
          tipoOperacion: invoiceDataGeneral.tipoOperacion,
          tipoSucursal:
            invoiceDataGeneral.tipoSucursal != ""
              ? invoiceDataGeneral.tipoSucursal
              : null,
          tipoTransaccionVenta:
            invoiceDataGeneral.tipoTransaccionVenta != ""
              ? invoiceDataGeneral.tipoTransaccionVenta
              : null,
          pagoPlazos: informacionPagos ? informacionPagos : null,
          pedidoComercialFacturaDto:
            Object.keys(informacionComercial).length !== 0
              ? informacionComercial
              : null,
          rucsAutorizados: rucsAutorizados ? rucsAutorizados : null,
          envioContenedorReceptor: invoiceDataGeneral.envioContenedorReceptor,
          informacionDatosExportacion:
            Object.keys(exportInvoice).length !== 0 ? exportInvoice : null,
          documentosFiscalesReferenciados: documentsFiscalReference
            ? documentsFiscalReference
            : null,
          localEntrega:
            Object.keys(informationDeliveryPlace).length !== 0
              ? informationDeliveryPlace
              : null,
          codigoRetencion:
            retentionInfoInvoice.length > 0
              ? retentionInfoInvoice[0].nombre
              : null,
          informacionAdicional:
            additionalInfoInvoice
              ? JSON.stringify(infos)
              : null,
        };
      }
    } else {
      setOpenLoader(false);
      return null;
    }
  };

  const validatePrerequisities = (ride) => {
    const tk = tokenUser ? tokenUser : "";
    if (tk !== "") {
      setOpenLoader(true);
      checkPreRequirements(getSub(tk), getRUCEmpresa(tk), dispatch)
        .then((newErrorsCompany) => {
          if (Array.isArray(newErrorsCompany)) {
            if (newErrorsCompany.length === 0) {
              if (ride) {
                generateRide();
              } else {
                
                generateInvoice();
                //getNumberVouchers(configGetNumberVoucher)
              }
            } else {
              selectedResource({
                id: -4,
                nameMenu: "Verificando pre-requisitos",
                titlePage: "Verificando pre-requisitos",
                titleTab: "Inicio",
                menuPadre: "",
              });
            }
          }
        })
        .catch(() => {
          //setShowLoader(false);
          setOpenLoader(false);
        });
    }
  };

  //para generar la factura
  const generateInvoice = async () => {
    
    let invoice = createFactura();
    if (invoice !== null) {
      await httpCore
        .post(`/generacion/comprobantes?codigoPlantilla=`+updateTemplate, invoice)
        .then((response) => {
          if (response.status === 200) {
          }
          //para actualizar el contador de comprobantes
          dispatch(
            getNumberVoucherSuccess(response.numeroComprobantesDisponibles)
          );
          //Para limpiar los datos del comprobante
          clearAllData();
          setOpenLoader(false);
          selectedResource({
            id: -4,
            nameMenu: "Verificando pre-requisitos",
            titlePage: "Verificando pre-requisitos",
            titleTab: "Inicio",
            menuPadre: "",
          });
          msmSwalExito(
            "Comprobante generado",
            `En breve será enviado al PAC para su autorización.`,
            { show: true, text: "Ver Comprobantes Pendientes" }
          ).then((response) => {
            if (response.isDismissed) {
              selectedResource({
                id: "PEN",
                nameMenu: "Pendientes",
                titlePage: "Pendientes",
                titleTab: "Comp. Pendientes",
                menuPadre: "REP",
              });
            }
          });
        })
        .catch((exception) => {
          if (exception.response) {
            msmSwalError(
              exception.response.data.apierror
                ? exception.response.data.apierror.mensajeSistema
                  ? exception.response.data.apierror.mensajeSistema
                  : "Error al generar el comprobante."
                : "Error al generar el comprobante."
            );
          } else {
            msmSwalError(
              "Existen problemas en la red. Contáctese con el administrador del Sistema."
            );
          }
          setOpenLoader(false);
        });
    }
  };

  const generateRide = async () => {
    let invoice = createFactura();
    if (invoice !== null) {
      setOpenLoader(true);
      //validatePrerequisities();
      return await clientBackendPDF
        .post(`/generacion/comprobantes/cafe/comprobante?codigoPlantilla=`+updateTemplate, invoice)
        .then((response) => {
          //Create a Blob from the PDF Stream
          const file = new Blob([response.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          setOpenLoader(false);
          //Open the URL on new Window
          window.open(fileURL);
          msmSwalExito("CAFE generado");
        })
        .catch((exception) => {
          if (exception.response) {
            console.error("error", { exception });
            msmSwalError(
              exception.response.data.apierror
                ? exception.response.data.apierror.mensaje
                  ? exception.response.data.apierror.mensaje
                  : "Error al generar el cafe."
                : "Error al generar el cafe."
            );
          } else {
            msmSwalError(
              "Existe problemas en la red. Contáctese con el administrador del Sistema."
            );
          }
          setOpenLoader(false);
        });
    }
  };

  const validation = () => {
    let result = true;
    const errors = {};
    //if (Number(validateMultiplePayment()) === Number(bigDecimal.add(totals.totalFactura,propina?propina:0))) {
    if (!validationTip()) {
      errors.tip =
        "La propina no puede ser mayor al 10% del valor del comprobante";
      result = false;
    }
    if (Object.entries(idCliente).length === 0) {
      errors.cliente = "Ingrese el cliente";
      result = false;
    }

    if (invoiceDataGeneral.tiempoPago === "2" && informacionPagos.length === 0) {
      errors.pagoPlazos = "Ingrese la información de pago a plazo, porque el tiempo de pago ingresado es crédito/plazo.";
      result = false;
    }

    ErrorsAlert(errors);
    return result;
  };

  const validateMultiplePayment = () => {
    let sum = pagos.reduce(function (acc, pago) {
      return Number(acc) + Number(pago.valor);
    }, 0);

    return sum;
  };

  const validateParametersPayment = () => {
    if (pagos.length === 1) {
      // if (typeof pagos[0].plazo === 'undefined' || pagos[0].plazo.trim() === '') {

      //     return false;
      // } else {
      return true;
      // }
    } else if (pagos.length === 0) {
      return false;
    } else {
      return true;
    }
  };

  const validationTip = () => {
    let recommendedTip = bigDecimal.multiply(totals.totalFactura, "0.10");
    return Number(propina) <= Number(recommendedTip);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const clearForm = () => {
    ConfirmAlert(
      `¿Está seguro de limpiar los datos del formulario?`,
      "",
      iconsAlert.question,
      true,
      "Sí",
      "Cancelar",
      () => {
        clearAllData();
      },
      () => { }
    );
  };

  return (
    <Fragment>
      <div className={classes.root} justifyContent="absolute">
        <Grid item xs={12} md={4} align="center" className={classes.divButton}>
          <AddTemplateBtn
          updateTemplate={updateTemplate}
          setUpdateTemplate={setUpdateTemplate}
          sendTemplate={1}
          setSendTemplate={setSendTemplate}
          iDoc={invoiceDataGeneral.iDoc}
          txt={"Visualizar CAFE"}
          ></AddTemplateBtn>
        </Grid>
        <Grid item xs={12} md={4} align="center" className={classes.divButton}>
          <AddTemplateBtn
          updateTemplate={updateTemplate}
          setUpdateTemplate={setUpdateTemplate}
          sendTemplate={2}
          setSendTemplate={setSendTemplate}
          iDoc={invoiceDataGeneral.iDoc}
          txt={"Firmar y autorizar"}
          ></AddTemplateBtn>
        </Grid>
        <Grid item xs={12} md={4} align="center">
          <Button
            onClick={clearForm}
            variant="text"
            className={classes.btnReport}
            fullWidth
          >
            <DeleteSweepIcon
              style={{ color: palette.error.main, marginRight: "10px" }}
              fontSize="large"
            />
            Limpiar Formulario
          </Button>
        </Grid>

        <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
          <DialogTitle>Advertencia</DialogTitle>
          <DialogContent>
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                md={12}
                className={classes.msgDialog}
                align="center"
              >
                {msg}
              </Grid>
              <Grid item xs={12} md={12}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleClose}
                >
                  Cerrar
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
        <Backdrop className={classes.backdrop} open={openLoader}>
          <CircularProgress color="primary" />
        </Backdrop>
      </div>
    </Fragment>
  );
};

export default ElectronicVoucherOptions;
